import type { Duration } from '@/types';

export const formatDuration = (duration: Duration | null): string => {
  if (!duration) return '∞';
  const { measure, number } = duration;

  if (number === 1) {
    switch (measure) {
      case 'Days':
        return '1 day';
      case 'Weeks':
        return '1 week';
      case 'Months':
        return '1 month';
      case 'Years':
        return '1 year';
    }
  }

  return `${number} ${measure.toLowerCase()}`;
};
